import type { LinkToModuleSignature } from '@efdigital/ll-addon-content/types/components/parts/link-to-module';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { array } from '@ember/helper';
import { LinkTo } from '@ember/routing';

const LinkToModule: TemplateOnlyComponent<LinkToModuleSignature> = <template>
  <LinkTo
    @route="programs.program.cohort.content.module"
    @models={{array @program.id @cohort.id @module.id}}
    ...attributes
  >{{yield}}</LinkTo>
</template>;

export { LinkToModule };
